import { useEffect } from "react";

export function useServiceWorker() {
  useEffect(() => {
    // Only register service worker in production and if supported
    if (
      typeof window !== "undefined" &&
      "serviceWorker" in navigator &&
      process.env.NODE_ENV === "production"
    ) {
      const registerSW = async () => {
        try {
          const registration = await navigator.serviceWorker.register(
            "/sw.js",
            {
              scope: "/",
            }
          );

          // Service Worker registered successfully

          // Handle updates
          registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener("statechange", () => {
                if (
                  newWorker.state === "installed" &&
                  navigator.serviceWorker.controller
                ) {
                  // New content is available, notify user
                  // You could show a toast notification here
                }
              });
            }
          });

          // Listen for messages from service worker
          navigator.serviceWorker.addEventListener("message", event => {
            // Handle message from Service Worker
          });
        } catch (error) {
          console.error("Service Worker registration failed:", error);
        }
      };

      // Register on page load
      registerSW();

      // Handle PWA install prompt
      let deferredPrompt: Event | null = null;

      window.addEventListener("beforeinstallprompt", e => {
        // Prevent the mini-infobar from appearing on mobile
        e.preventDefault();
        // Stash the event so it can be triggered later
        deferredPrompt = e;
      });

      window.addEventListener("appinstalled", () => {
        deferredPrompt = null;
      });
    } else {
      // Service Worker not supported or not in production
    }
  }, []);
}
